module.exports = __webpack_public_path__ + "img/D201708_2.bc83712d.jpg";